<template>
  <div>
    <b-modal v-model="showModal"
      title="Cambiar Contraseña"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="cancel"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc>
      <b-overlay :show="loading" rounded="sm">

        <p>Nueva contraseña para el usuario <strong>{{ code }}</strong>:</p>

        <div class="form-group">
          <label for="new_password"><b>Contraseña&nbsp;<span class="asterisk">*</span></b></label>
          <div class="input-group">
            <input v-model="form.password" :type="showPlain ? 'text' : 'password'" class="form-control"
                   id="new_password" name="new_password" placeholder="Contraseña" autocomplete="new-password">
            <div class="input-group-append">
              <button class="btn btn-sm btn-secondary" type="button" @click="showPlain = !showPlain"
                      :title="showPlain ? 'Ocultar' : 'Mostrar'">
                <i class="fas fa-fw" :class="showPlain ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
              <button class="btn btn-sm btn-info" type="button" @click="generate" title="Generar contraseña aleatoria">
                <i class="fas fa-key fa-fw"></i> Generar
              </button>
            </div>
          </div>
          <span v-if="passwordValid" class="text-danger" style="font-size: 10px;"><b>El campo Contraseña es requerido.</b></span>
          <span v-if="passwordLength" class="text-danger" style="font-size: 10px;"><b>La Contraseña debe tener al menos 8 caracteres.</b></span>
        </div>

        <div class="form-group">
          <label for="new_password_confirmation"><b>Confirmar Contraseña&nbsp;<span class="asterisk">*</span></b></label>
          <input v-model="form.password_confirmation" :type="showPlain ? 'text' : 'password'" class="form-control"
                 id="new_password_confirmation" name="new_password_confirmation" placeholder="Confirmar Contraseña" autocomplete="new-password">
          <span v-if="password_compareValid" class="text-danger" style="font-size: 10px;"><b>Las Contraseñas no coinciden.</b></span>
        </div>

        <small class="text-muted d-block">
          Al generar una contraseña se muestra en pantalla para que pueda copiarla.
        </small>
        <small class="text-muted d-block mt-1">
          <i class="fas fa-envelope fa-fw"></i> Al guardar se enviará al usuario un correo con sus datos de acceso.
        </small>

        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
          <button class="btn btn-sm btn-success" type="button" @click="submit"> <i class="fas fa-download fa-fw"></i> Guardar</button>
        </div>

      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BOverlay } from 'bootstrap-vue';

// Sin caracteres ambiguos (0/O, 1/l/I) para que se pueda dictar sin errores.
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGIT = '23456789';
const PASSWORD_LENGTH = 12;

export default {
  components: { BModal, BOverlay },
  props: ['id', 'code', 'showModal'],
  data() {
    return {
      form: {
        password: '',
        password_confirmation: '',
      },
      showPlain: false,
      passwordValid: false,
      passwordLength: false,
      password_compareValid: false,
      loading: false,
    }
  },
  methods: {
    resetForm() {
      // Se vacía siempre al cerrar: la contraseña en claro no debe quedar en el DOM.
      this.form = { password: '', password_confirmation: '' };
      this.showPlain = false;
      this.passwordValid = false;
      this.passwordLength = false;
      this.password_compareValid = false;
    },
    close() {
      this.$emit('update:showModal', false);
      this.$emit('getRecords');
    },
    cancel() {
      this.$emit('update:showModal', false);
    },
    /**
     * Entero aleatorio en [0, max) sin sesgo, con crypto y no con Math.random.
     */
    randomInt(max) {
      const limit = Math.floor(0xFFFFFFFF / max) * max;
      const buf = new Uint32Array(1);
      let value;
      do {
        window.crypto.getRandomValues(buf);
        value = buf[0];
      } while (value >= limit);
      return value % max;
    },
    generate() {
      const all = LOWER + UPPER + DIGIT;

      // Se garantiza al menos una de cada clase y el resto se completa al azar.
      const chars = [
        LOWER[this.randomInt(LOWER.length)],
        UPPER[this.randomInt(UPPER.length)],
        DIGIT[this.randomInt(DIGIT.length)],
      ];
      while (chars.length < PASSWORD_LENGTH) {
        chars.push(all[this.randomInt(all.length)]);
      }

      // Barajado Fisher-Yates: si no, las 3 primeras posiciones serían predecibles.
      for (let i = chars.length - 1; i > 0; i--) {
        const j = this.randomInt(i + 1);
        [chars[i], chars[j]] = [chars[j], chars[i]];
      }

      const password = chars.join('');
      this.form.password = password;
      this.form.password_confirmation = password;
      // Se revela: el administrador tiene que poder leerla para entregarla.
      this.showPlain = true;
      this.passwordValid = false;
      this.passwordLength = false;
      this.password_compareValid = false;
    },
    submit() {
      this.passwordValid = false;
      this.passwordLength = false;
      this.password_compareValid = false;

      if (this.form.password == '' || this.form.password == null) { this.passwordValid = true; }
      if (this.form.password) {
        if (this.form.password.length < 8) { this.passwordLength = true; }
        if (this.form.password !== this.form.password_confirmation) { this.password_compareValid = true; }
      }

      if (this.passwordValid || this.passwordLength || this.password_compareValid) {
        return;
      }

      this.loading = true;

      axios.post('/configuration/users/changePassword', {
        id: this.id,
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
      })
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            // Si la clave se generó al azar, el correo es la única forma de que el
            // usuario la conozca: hay que avisar cuando no sale.
            if (response.data.mail === 'failed') {
              toastr.warning('No se pudo enviar el correo. Entrégale la contraseña por otro medio.', 'Aviso', { icon: 'fa fa-exclamation-circle' });
            }
            this.close();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error('No se pudo cambiar la contraseña', 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>
